import AdditionalCoverages from './AdditionalCoverages';

export default AdditionalCoverages;
